/* eslint-disable */
/* prettier-ignore */

export const TRANSLATIONS_BG = {
  "  Checked by (signature)": "  Проверено от (подпис)",
  "! 3 of 4 types required:": "! Изискват се 3 от 4 типа:",
  "! Min. 14 characters": "! Мин. 14 знака",
  "! No name/username parts": "! Без части от име/потребителско име",
  "! No spaces": "! Без интервали",
  "/ occasion": "/ случай",
  "A new password should be different than the current one": "Новата парола трябва да бъде различна от текущата.",
  "ACCEPTED": "ПРИЕТО",
  "Active flights": "Активни полети",
  "Add deicing/anti-icing": "Добавете размразяване/противозамръзване",
  "Add description": "Добавете описание",
  "Add description if there is a irregularity!": "Добавете описание, ако има нередност!",
  "Add line": "Добавете линия",
  "Add location where item was found": "Добавете местоположението, където е намерен предметът",
  "Add note": "Добавете бележка",
  "add occasion": "добавяне на случай",
  "Add other location": "Добавете друго местоположение",
  "Add row": "Добавете ред",
  "Add storage location": "Добавете място за съхранение",
  "Add your recovery email so we can send you a code if you ever forget your password.": "Добавете вашия имейл за възстановяване, за да можем да ви изпратим код, ако забравите паролата си.",
  "additional services": "допълнителни услуги",
  "After clicking 'CONFIRM', the correction MVT will be sent. It can be re-sent if there is a change in ALDT or/and AIBT.": "След натискане на 'ПОТВЪРДИ', коригиращото MVT съобщение ще бъде изпратено. Може да бъде изпратено отново при промяна в ALDT или/и AIBT.",
  "After clicking 'CONFIRM', the MVT will be sent. It can be re-sent if there is a change in ALDT or/and AIBT.": "След натискане на 'ПОТВЪРДИ', MVT ще бъде изпратен. Може да бъде изпратен отново при промяна в ALDT или/и AIBT.",
  "Agent's name:": "Име на агента:",
  "Agent's signature:": "Подпис на агента:",
  "Aircraft Damage": "Повреда на самолета",
  "Aircraft type": "Тип самолет",
  "Airline": "Авиокомпания",
  "All": "Всички",
  "ALL": "ВСИЧКИ",
  "All Airlines with Stocks": "Всички авиокомпании със складови наличности",
  "An error occurred while trying to verify your email address.": "Възникна грешка при опит за потвърждение на вашия имейл адрес.",
  "and": "и",
  "and/or": "и/или",
  "Anti-icing": "Противозамръзване",
  "Any email with @aviapartner.aero or @aviavip.com is not accepted!": "Всеки имейл с @aviapartner.aero или @aviavip.com не се приема!",
  "APPLY": "ПРИЛОЖИ",
  "approved": "одобрено",
  "Apr": "Апр",
  "Archived": "Архивирано",
  "Are you sure you want to change your password?": "Сигурни ли сте, че искате да промените паролата си?",
  "Are you sure you want to exit the current process?": "Сигурни ли сте, че искате да излезете от текущия процес?",
  "Are you sure you want to remove photo?": "Сигурни ли сте, че искате да премахнете снимката?",
  "Are you sure you want to sign out?": "Сигурни ли сте, че искате да излезете?",
  "area": "зона",
  "Arrival MVT has been sent": "MVT за пристигане е изпратен",
  "Arrival MVT not sent yet": "MVT за пристигане все още не е изпратен",
  "Arrival MVT sending": "Изпращане на MVT за пристигане",
  "Arrival MVT sent successfully": "MVT за пристигане е изпратен успешно",
  "Attach photo": "Прикачете снимка",
  "Attachment": "Прикачен файл",
  "Aug": "Авг",
  "Available": "Налично",
  "Belt": "Пояс",
  "Body": "Фюзелаж",
  "Briefly describe where the item will be stored for picking up.": "Опишете накратко къде ще бъде съхраняван предметът за вземане.",
  "Call {{firstName}} {{lastName}}": "Обадете се на {{firstName}} {{lastName}}",
  "Call sign": "Позивна",
  "Cancel": "Отказ",
  "CANCEL": "ОТКАЗ",
  "Cannot be after": "Не може да бъде след",
  "Cannot be before": "Не може да бъде преди",
  "Cannot create MVT message: missing flight information": "Не може да се създаде MVT съобщение: липсваща информация за полета",
  "Cannot send Arrival MVT": "Не може да се изпрати MVT за пристигане. Адресите (SITA и/или имейл) за този полет не са конфигурирани в Sunrise.",
  "Cannot send Arrival MVT. Addresses (SITA and/or email) for this flight are not configured in Sunrise.": "Не може да се изпрати MVT за пристигане. Адресите (SITA и/или имейл) за този полет не са конфигурирани в Sunrise.",
  "Cannot send MVT ETD": "Не може да се изпрати MVT ETD. Адресите (SITA и/или имейл) за този полет не са конфигурирани в Sunrise.",
  "Cannot send MVT ETD. Addresses (SITA and/or email) for this flight are not configured in Sunrise.": "Не може да се изпрати MVT ETD. Адресите (SITA и/или имейл) за този полет не са конфигурирани в Sunrise.",
  "Cannot set a future time.": "Не може да се зададе бъдещо време.",
  "Change": "Промяна",
  "Change password": "Промяна на паролата",
  "Change password?": "Промяна на паролата?",
  "Change your password:": "Променете вашата парола:",
  "Checked by (signature)": "  Проверено от (подпис)",
  "Checks on easily visible parts of the aircraft from the ground": "Проверки на лесно видимите части на самолета от земята. Няма очевидни повреди или аномалии на:",
  "Checks on easily visible parts of the aircraft from the ground. No obvious damage or anomalies to:": "Проверки на лесно видимите части на самолета от земята. Няма очевидни повреди или аномалии на:",
  "Chocks": "Клинове",
  "Chute": "Тръба",
  "CLEAR": "ИЗЧИСТИ",
  "Client's signature:": "Подпис на клиента:",
  "Clocked Time": "Отчетено време",
  "Close": "Затвори",
  "CLOSE": "ЗАТВОРИ",
  "Close all my sessions on all devices": "Затворете всички мои сесии на всички устройства",
  "Close registration": "Затваряне на регистрацията",
  "CLOSE REGISTRATION": "ЗАТВОРИ РЕГИСТРАЦИЯТА",
  "close the flight": "затваряне на полета",
  "Closed": "Затворен",
  "Closing this window will discard all your recent changes.": "Затварянето на този прозорец ще отмени всички ваши последни промени.",
  "Clouds": "Облаци",
  "Comment": "Коментар",
  "Comment...": "Коментар...",
  "Comments": "Коментари",
  "Completed": "Завършено",
  "Conditional services": "Условни услуги",
  "Cones": "Конуси",
  "CONFIRM": "ПОТВЪРДИ",
  "Confirm": "Потвърди",
  "Confirm new password": "Потвърдете новата парола",
  "Confirm remove?": "Потвърдете премахването?",
  "CONFIRMED": "ПОТВЪРДЕНО",
  "Contact your administrator to request access": "Свържете се с администратора си, за да поискате достъп",
  "Could not save data, please try again later": "Не може да се запазят данните, моля опитайте отново по-късно",
  "Crew signature": "Подпис на екипажа",
  "Current password": "Текуща парола",
  "Damage": "Повреда",
  "Date range": "Период от дати",
  "Date should not be before start date": "Датата не трябва да бъде преди началната дата",
  "Day": "Ден",
  "Dec": "Дек",
  "DECLINED": "ОТХВЪРЛЕНО",
  "Default station": "Станция по подразбиране",
  "Deicing": "Размразяване",
  "Deicing Service Registration": "Регистрация на услуга за размразяване",
  "Delete Photo": "Изтрий снимка",
  "DENIED": "ОТКАЗАНО",
  "Describe location": "Опишете местоположението",
  "Dest.": "Дест.",
  "Destination": "Дестинация",
  "Did you forget something?": "Забравихте ли нещо?",
  "Don't use phone while driving!": "Не използвайте телефона, докато шофирате!",
  "Dummy Type": "Фиктивен тип",
  "Edit Comment": "Редактирайте коментар",
  "Emergency": "Спешно",
  "Emergency contacts are not set up": "Спешните контакти не са настроени",
  "employees": "служители",
  "End": "Край",
  "End of anti-icing": "Край на противозамръзяването",
  "End Time": "Крайно време",
  "End time should not be before start time": "Крайното време не трябва да бъде преди началното време",
  "Entrance": "Вход",
  "Error loading clocked times": "Грешка при зареждане на отчетеното време",
  "Error. The email doesn't meet standard formatting.": "Грешка. Имейлът не отговаря на стандартното форматиране.",
  "exceeds the allowed limit for this flight": "надвишава разрешената граница за този полет",
  "Executor's name:": "Име на изпълнителя:",
  "Executor's signature:": "Подпис на изпълнителя:",
  "extra service": "допълнителна услуга",
  "Extra services": "Допълнителни услуги",
  "Extra shift request": "Заявка за допълнителна смяна",
  "Extra Shift Request": "Заявка за допълнителна смяна",
  "Extra shift request confirmed": "Заявката за допълнителна смяна е потвърдена",
  "failed": "неуспешно",
  "Feb": "Фев",
  "Filter": "Филтър",
  "Filter group": "Група филтри",
  "Filter group has not been updated": "Групата филтри не е актуализирана",
  "filter group not found": "групата филтри не е намерена",
  "finalization": "финализиране",
  "Find the account recovery section and click \"Resend verification email\".": "Намерете раздела за възстановяване на акаунт и кликнете на \"Изпрати отново имейл за потвърждение\".",
  "FirebaseError: A document cannot be written because it exceeds the  maximum size allowed": "FirebaseError: Документът не може да бъде записан, защото надвишава максимално разрешения размер",
  "FirebaseError: A document cannot be written because it exceeds the maximum size allowed": "FirebaseError: Документът не може да бъде записан, тъй като надвишава максималния разрешен размер.",
  "Flight": "Полета",
  "Flight details": "Детайли за полета",
  "Flight information registration": "Регистрация на информация за полета",
  "Flight not found": "Полетът не е намерен",
  "Flight number/registration": "Номер на полета/регистрация",
  "Flight registration is closed": "Регистрацията на полета е затворена",
  "Flight reopened": "Полетът е отворен отново",
  "Flight type": "Тип полет",
  "Flights": "Полети",
  "Fluid name": "Име на течност",
  "Fluid name:": "Име на течността:",
  "Fluid type": "Тип течност",
  "Forgot your password?": "Забравили сте паролата си?",
  "Forms": "Формуляри",
  "from": "от",
  "From": "От",
  "Full (Wings, stabilizer &, fuselage)": "Пълен (Крила, стабилизатор и фюзелаж)",
  "Future time is not allowed": "Бъдещо време не е разрешено",
  "Gate": "Порта",
  "General info": "Обща информация",
  "Go to flights": "Към полети",
  "Go to login": "Към вход",
  "Go to My Profile in your Sunrise account.": "Отидете в Моят профил във вашия Sunrise акаунт.",
  "Go to Unread R&S": "Към непрочетените R&S",
  "Helpdesk": "Помощен център",
  "Hold Inspection on Arrival": "Проверка на товарно помещение при пристигане",
  "Hold Inspection on Departure": "Проверка на товарно помещение при заминаване",
  "hr": "ч",
  "Humidity": "Влажност",
  "If damage is found, mark it on the sketch": "Ако бъде открита повреда, маркирайте я на скицата",
  "If the problem continues, go to My Profile to resend a new verification link.": "Ако проблемът продължава, отидете в Моят профил, за да изпратите отново нова връзка за потвърждение.",
  "In order to close this flight you need to provide": "За да затворите този полет, трябва да предоставите задължителни подробности.",
  "In order to close this flight you need to provide mandatory details.": "За да затворите този полет, трябва да предоставите задължителни подробности.",
  "In order to open 'Calendar', read and process recent Read & Sign messages.": "За да отворите 'Календар', прочетете и обработете последните съобщения Прочети и подпиши.",
  "In order to send Arrival MVT you need to provide mandatory details": "За да изпратите MVT за пристигане, трябва да предоставите задължителни подробности.",
  "Include nearby area": "Включете близката област",
  "Included nearby area": "Включена близка зона",
  "Incorrect code": "Неправилен код",
  "Input a brief description here": "Въведете кратко описание тук",
  "Inspected by": "Инспектирано от",
  "Inspection agent's signature": "Подпис на инспекционния агент",
  "Inspection agent's signature:": "Подпис на инспекционния агент:",
  "Inspections": "Проверки",
  "Instructions": "Инструкции",
  "Internal communication": "Вътрешна комуникация",
  "Invalid ALDT/AIBT value or Arrival MVT with such ALDT and AIBT values already exist": "Невалидна стойност на ALDT/AIBT или MVT за пристигане с такива стойности на ALDT и AIBT вече съществува",
  "is logged in": "е влязъл в системата",
  "Is Partial": "Е частично",
  "is signed in": "е влязъл",
  "It's safe and encrypted - only used for password resets.": "Той е безопасен и криптиран - използва се само за нулиране на пароли.",
  "Jan": "Ян",
  "Job vacancy": "Обява за работа",
  "Jul": "Юл",
  "Jun": "Юн",
  "KEY PEOPLE": "КЛЮЧОВИ ХОРА",
  "Language": "Език",
  "Leave a comment about this timestamp and connected action.": "Оставете коментар за този времеви печат и свързаното действие.",
  "Left Engine": "Ляв двигател",
  "Left Tail Wing": "Ляво опашно крило",
  "Left Wing": "Ляво крило",
  "Load Verification Cross-Check Form": "Формуляр за кръстосана проверка на товара",
  "Local (Under Wing / Local area contamination)": "Локално (Под крилото / Локално замърсяване)",
  "Local Bags": "Местни чанти",
  "Locked application": "Заключено приложение",
  "Log in": "Вход",
  "Log out": "Изход",
  "Lost item": "Изгубен предмет",
  "lowercase": "малки букви",
  "Mar": "Мар",
  "Mark location": "Маркирайте местоположението",
  "May": "Май",
  "Message archived": "Съобщението е архивирано",
  "Message state": "Състояние на съобщението",
  "Message type": "Тип съобщение",
  "Message unarchived": "Съобщението не е архивирано",
  "Messages": "Съобщения",
  "messages yet": "съобщения все още",
  "min": "мин",
  "Mix": "Смес",
  "Month": "Месец",
  "MVT History": "История на MVT",
  "My profile": "Моят профил",
  "Name Surname": "Име Фамилия",
  "Neck": "Врат",
  "New password": "Нова парола",
  "New password cannot be equal to current": "Новата парола не може да бъде същата като текущата",
  "New password does not meet security requirements": "Новата парола не отговаря на изискванията за сигурност",
  "next": "следващ",
  "Next 5 days": "Следващите 5 дни",
  "No": "Не",
  "No active flights yet": "Няма активни полети все още",
  "No clocked times available": "Няма налични отчетени времена",
  "No content yet...": "Все още няма съдържание...",
  "No flight details information": "Няма информация за детайлите на полета",
  "No instructions found": "Не са намерени инструкции",
  "No internet connection": "Няма интернет връзка",
  "No key people assigned.": "Няма назначени ключови лица.",
  "No messages yet": "Все още няма съобщения",
  "No photo available": "Няма налична снимка",
  "No photos here yet": "Все още няма снимки тук",
  "No registration": "Няма регистрация",
  "No services available": "Няма налични услуги",
  "No time logging found": "Не е намерено отчетено време",
  "No timestamps configured for this flight type": "Няма конфигурирани времеви печати за този тип полет",
  "No types here yet": "Все още няма типове тук",
  "no user data": "няма потребителски данни",
  "None": "Няма",
  "Nose": "Нос",
  "Not completed": "Не е завършено",
  "Note": "Забележка:",
  "Nov": "Ное",
  "NOW": "СЕГА",
  "Number of unread R&S:": "Брой непрочетени R&S:",
  "numbers": "цифри",
  "occasion": "случай",
  "Occasion": "Случай",
  "Oct": "Окт",
  "Oops! It looks like your verification email didn't go through.": "Опа! Изглежда, че вашият имейл за потвърждение не е преминал.",
  "Open": "Отворен",
  "Open a flight to add it to your active flights list.": "Отворете полет, за да го добавите към списъка с активни полети.",
  "Open file": "Отваряне на файл",
  "Open flight {{name}}": "Отворете полет {{name}}",
  "Operation flight number": "Оперативен номер на полета",
  "Operator's name": "Име на оператора",
  "Operator's name:": "Име на оператора:",
  "Operator's signature": "Подпис на оператора",
  "Operator's signature:": "Подпис на оператора:",
  "Optional": "По избор",
  "or": "или",
  "Origin": "Произход",
  "Other flights": "Други полети",
  "Outside Air Temperature": "Външна температура на въздуха (C°)",
  "Outside Air Temperature (C°)": "Външна температура на въздуха (C°)",
  "Page not found": "Страницата не е намерена",
  "Parking": "Паркинг",
  "Partially (Wings & stabilizer only)": "Частично (Само крила и стабилизатор)",
  "Password": "Парола",
  "Password must be at least 8 characters": "Паролата трябва да съдържа поне 8 знака и да съдържа поне 1 главна и 1 малка буква, 1 символ, 1 цифра и без интервали.",
  "Password Not Unique. Your new password cannot be one of your last 5 used passwords.": "Паролата не е уникална. Вашата нова парола не може да бъде една от последните ви 5 използвани пароли.",
  "Passwords do not match": "Паролите не съвпадат",
  "per occasion": "на случай",
  "Per pax": "На пътник",
  "per start": "за старт",
  "percent": "процент",
  "Photo registration": "Регистрация на снимки",
  "Photo types required": "Изискват се типове снимки",
  "Photo types required:": "Изисквани типове снимки:",
  "Photos": "Снимки",
  "Pick if its a damaged part or lost item": "Изберете дали е повредена част или изгубен предмет",
  "Pin on schema": "Закачете на схемата",
  "Please briefly describe where you found the item": "Моля, опишете накратко къде сте намерили предмета. Посочете помещението или линията и реда, ако е възможно",
  "Please click here to proceed to flights list": "Моля, кликнете тук, за да продължите към списъка с полети",
  "Please make sure you attached photos of irregularities": "Моля, уверете се, че сте прикачили снимки на нередностите",
  "Please pick on scheme": "Моля, изберете от схемата",
  "Please reach out to your administrator for assistance": "Моля, свържете се с вашия администратор за помощ",
  "Please try sending it again later.": "Моля, опитайте да го изпратите отново по-късно.",
  "Please try the link again.": "Моля, опитайте връзката отново.",
  "Please, sign below": "Моля, подпишете по-долу",
  "Post-deicing/anti-icing check completed": "Проверката след размразяване/противозамръзване е завършена",
  "Precipitation": "Валежи",
  "Pressure": "Налягане",
  "Proceed to login": "Продължете към вход",
  "Product name": "Име на продукт",
  "Product type": "Тип продукт",
  "Profile": "Профил",
  "Profile data wasn't updated!": "Данните на профила не са актуализирани!",
  "Psychosocial aid": "Психосоциална помощ",
  "Quantity (liter)": "Количество (литра)",
  "Read": "Прочетено",
  "Read & Sign": "Прочети и подпиши",
  "Read & Sign to do:": "Прочетете и подпишете, за да направите:",
  "Read&Sign": "Прочети и подпиши",
  "Receive Extra shift requests": "Получаване на заявки за допълнителна смяна",
  "Receive job vacancies": "Получаване на обяви за работа",
  recovery: {
    "error1": "<1>Опа!</1> Изглежда, че вашият имейл за потвърдение не е преминал.",
    "error2": "<1>Моля, опитайте да го изпратите отново по-късно.</1>",
    "error3": "Извиняваме се за неудобството.",
    "inUse": "Този имейл за възстановяване вече се <1>използва!</1>",
    "success": "Имейлът за <1>потвърдение</1> е изпратен успешно!",
    validation: {
      "blockedDomainNote": "Всеки имейл с <1>@aviapartner.aero</1> или <3>@aviavip.com</3> не се приема!",
      "invalidFormat": "Грешка. Имейлът не отговаря на стандартното форматиране."
    },
    "verified": "Вашият имейл за възстановяване вече е <1>потвърден!</1>"
  },
  "Recovery email": "Имейл за възстановяване",
  "Recovery email already verified!": "Имейлът за възстановяване вече е потвърден!",
  "Recovery email verified!": "Имейлът за възстановяване е потвърден!",
  "Reg.": "Рег.",
  "Registration": "Регистрация",
  "Registration Closed": "Регистрацията е затворена",
  "REGISTRATION CLOSED": "РЕГИСТРАЦИЯТА Е ЗАТВОРЕНА",
  "registration complete": "регистрацията е завършена",
  "Remark": "Забележка",
  "Remove": "Премахни",
  "Remove {{name}} from active flights": "Премахнете {{name}} от активните полети",
  "Reopen": "Отвори отново",
  "reopen flight": "отваряне отново на полета",
  "Report any irregularities found upon arrival": "Докладвайте всички нередности, открити при пристигането",
  "Report any other irregularities": "Докладвайте всички други нередности",
  "Required": "Задължително",
  "required to close the flight": "необходимо за затваряне на полета",
  "Requirements of the password are not met.": "Изискванията за паролата не са изпълнени.",
  "Resend verification email": "Изпратете отново имейл за потвърждение",
  "Right Engine": "Десен двигател",
  "Right Tail Wing": "Дясно опашно крило",
  "Right Wing": "Дясно крило",
  "Runway": "Писта",
  "Safety Ramp Checklist": "Контролен списък за безопасност на рампата",
  "Safety Ramp Inspection": "Инспекция на безопасността на рампата",
  "SAVE": "ЗАПАЗИ",
  "save": "запази",
  "Save service registrations problem": "Проблем при запазване на регистрациите на услугите",
  "Screening": "Сканиране",
  "Search": "Търсене",
  "Seat": "Място",
  "Seats": "Места",
  "Select type": "Изберете тип",
  "SEND ARRIVAL MVT": "ИЗПРАТИ MVT ЗА ПРИСТИГАНЕ",
  "SEND CORRECTION ARRIVAL MVT": "ИЗПРАТИ КОРЕКЦИЯ НА MVT ЗА ПРИСТИГАНЕ",
  "Send the Arrival MVT message to recipients:": "Изпратете съобщението MVT за пристигане до получателите:",
  "SENT": "ИЗПРАТЕНО",
  "Sep": "Сеп",
  "Service info saved": "Информацията за услугата е запазена",
  "Service registration": "Регистрация на услуга",
  "Service registration is closed": "Регистрацията на услугата е затворена",
  "Service Type": "Тип услуга",
  "Set": "Задай",
  "Set date": "Задайте дата",
  "Set time": "Задайте време",
  "Set time: End of anti-icing": "Задайте време: Край на противозамръзяването",
  "Set to now": "Задай на сега",
  "Short remark": "Кратка забележка",
  "Show": "Покажи",
  "Show Photo": "Покажи снимка",
  "Sign for understanding": "Подпишете за разбиране",
  "Sign form below to complete it": "Подпишете формуляра по-долу, за да го завършите",
  "Sign in": "Вход",
  "Sign out": "Изход",
  "Signed": "Подписано",
  "SKIP": "ПРОПУСНИ",
  "Skip this step": "Пропуснете тази стъпка",
  "Something went wrong": "Нещо се обърка",
  "Something went wrong. Please try again later.": "Нещо се обърка. Моля, опитайте отново по-късно.",
  "Something wrong": "Нещо се обърка",
  "Sort.": "Сортиране",
  "Specify where did you found the item": "Уточнете къде сте намерили предмета",
  "Start": "Начало",
  "Start anti-icing": "Начало на противозамръзване",
  "Start Time": "Начално време",
  "Station": "Станция",
  "Stations": "Станции",
  "Stop anti-icing": "Край на противозамръзване",
  "success": "успех",
  "Sunrise": "Изгрев",
  "Sunset": "Залез",
  "Switch flight": "Смяна на полет",
  "symbols": "символи",
  "SYSTEM SETTINGS": "СИСТЕМНИ НАСТРОЙКИ",
  "Tail": "Опашка",
  "Take a photo": "Направете снимка",
  "Take a photo of a finished action, this timestamp is dedicated to.": "Направете снимка на завършено действие, на което този времеви печат е посветен.",
  "Tap on area where damaged part is located": "Натиснете на зоната, където се намира повредената част",
  "Task": "Задача",
  "Tasks & Flights": "Задачи и полети",
  "Telex messages": "Телекс съобщения",
  "Temperature (C°)": "Температура (C°)",
  "The app has been updated": "Приложението е актуализирано",
  "The APPI code is required when resetting your Aviapartner": "APPI кодът е необходим при нулиране на вашия Aviapartner",
  "The APPI code is required when resetting your Aviapartner account password in Sunrise or through the Aviapartner helpdesk. You can  always find your APPI code in your profile in Sunrise.": "APPI кодът е необходим при нулиране на паролата на вашия Aviapartner акаунт в Sunrise или чрез помощния център на Aviapartner. Винаги можете да намерите вашия APPI код в профила си в Sunrise.",
  "the correction MVT will be sent": "След натискане на 'ПОТВЪРДИ', коригиращото MVT съобщение ще бъде изпратено. Може да бъде изпратено отново при промяна в ALDT или/и AIBT.",
  "The current password you entered is incorrect.": "Текущата парола, която сте въвели, е неправилна.",
  "The current password you've entered is incorrect": "Текущата парола, която сте въвели, е неправилна. Моля, проверете отново и опитайте пак.",
  "The elapsed time between": "Изтеклото време между",
  "The end time must be later than the start time.": "Крайното време трябва да бъде по-късно от началното време.",
  "the MVT will be sent": "След натискане на 'ПОТВЪРДИ', MVT ще бъде изпратен. Може да бъде изпратен отново при промяна в ALDT или/и AIBT.",
  "The planning shown below might not be up-to-date": "Показаното по-долу планиране може да не е актуално",
  "The shift is already confirmed to": "Смяната вече е потвърдена на",
  "The username or password you've entered is incorrect": "Потребителското име или паролата, които сте въвели, са неправилни. Моля, проверете отново и опитайте пак.",
  "The username or password you've entered is incorrect. Please  double-check and try again.": "Потребителското име или паролата, които сте въвели, са неправилни. Моля, проверете отново и опитайте пак.",
  "The verification email has been sent successfully!": "Имейлът за потвърждение е изпратен успешно!",
  "This action is mandatory.": "Това действие е задължително.",
  "This field is mandatory": "Това поле е задължително",
  "This form is signed": "Този формуляр е подписан",
  "This message is marked as urgent": "Това съобщение е маркирано като спешно",
  "This recovery email is already in use!": "Този имейл за възстановяване вече се използва!",
  "This request is not valid anymore": "Тази заявка вече не е валидна",
  "This section is used to deal with visible damage to the airplane": "Този раздел се използва за работа с видими повреди на самолета. Моля, документирайте всеки забележим проблем преди да извършите каквито и да е услуги.",
  "This service has been registered for this flight over 80% of the time.": "Тази услуга е била регистрирана за този полет в над 80% от случаите.",
  "time": "време",
  "Time registration": "Регистрация на време",
  "Timeline": "Времева линия",
  "Timestamp information": "Информация за времеви печати",
  "Timestamps type": "Тип времеви печат",
  "to": "до",
  "To get a new one, simply follow these steps:": "За да получите нова, просто следвайте тези стъпки:",
  "Today": "Днес",
  "TODAY": "ДНЕС",
  "Tomorrow": "Утре",
  "Transfer Bags": "Чанти за трансфер",
  "Truck Driver": "Шофьор на камион",
  "Truck driver's signature": "Подпис на шофьора на камиона",
  "Truck driver's signature:": "Подпис на шофьора на камиона:",
  "Truck Number": "Номер на камиона",
  "type": "тип",
  "Type": "Тип",
  "Unavailable": "Недостъпно",
  "Unread": "Непрочетено",
  "Until": "До",
  "Unverified email": "Непотвърден имейл",
  "uppercase": "главни букви",
  "Username": "Потребителско име",
  "Username or email": "Потребителско име или имейл",
  "validating": "валидиране",
  "validation": "валидация",
  "Verification Error": "Грешка при потвърждение",
  "Verification Link Expired": "Връзката за потвърждение е изтекла",
  "Verified email": "Потвърден имейл",
  verify: {
    "alreadyVerifiedTitle": "Имейлът за възстановяване вече е потвърден!",
    "error1": "Възникна грешка при опит за потвърждение на вашия имейл адрес.",
    "error2": "Моля, опитайте връзката отново.",
    "error3": "Ако проблемът продължава, отидете в <1>Моят профил</1>, за да изпратите отново нова връзка за потвърждение.",
    "errorTitle": "Грешка при потвърждение",
    "expiredStep1": "Отидете в <1>Моят профил</1> във вашия Sunrise акаунт.",
    "expiredStep2": "Намерете раздела за възстановяване на акаунт и кликнете на \"Изпрати отново имейл за потвърждение\".",
    "expiredStepsIntro": "За да получите нова, просто следвайте тези стъпки:",
    "expiredTitle": "Връзката за потвърждение е изтекла",
    "successDescription": "Сега можете да го използвате, за да възстановите достъп до акаунта си, ако забравите паролата си.",
    "successTitle": "Имейлът за възстановяване е потвърден!",
    "verifying": "Проверява се..."
  },
  "Verifying...": "Проверява се...",
  "View key people": "Вижте ключовите хора",
  "Visibility": "Видимост",
  "Visual checks must be performed AFTER GSE removal": "Визуалните проверки трябва да се извършат СЛЕД премахване на GSE",
  "Visual checks must be performed BEFORE GSE positioning": "Визуалните проверки трябва да се извършат ПРЕДИ позициониране на GSE",
  "Walkaround Arrival Checklist": "Контролен списък за обхождане при пристигане",
  "Walkaround Pre-Departure Checklist": "Контролен списък за обхождане преди заминаване",
  "We apologize for the inconvenience.": "Извиняваме се за неудобството.",
  "We strongly recommend saving it in your smartphone phonebook": "Силно препоръчваме да го запазите в телефонния указател на вашия смартфон",
  "We strongly recommend saving it in your smartphone phonebook so that you always have the APPI code at hand. To save the code, go to your Sunrise profile and scan the QR code with your smartphone.": "Силно препоръчваме да го запазите в телефонния указател на вашия смартфон, за да имате винаги APPI кода под ръка. За да запазите кода, отидете в профила си в Sunrise и сканирайте QR кода с вашия смартфон.",
  "Weather": "Време",
  "Wind": "Вятър",
  "Would you like to add it to your current registration?": "Бихте ли искали да я добавите към вашата текуща регистрация?",
  "Write comment": "Напишете коментар",
  "write new comment": "напишете нов коментар",
  "Write your comment here, then press the green check mark": "Напишете вашия коментар тук, след това натиснете зелената отметка.",
  "Year": "Година",
  "Yes": "Да",
  "Yesterday": "Вчера",
  "You are offline": "Вие сте офлайн",
  "You can check your APPI code on Sunrise portal.": "Можете да проверите вашия APPI код на портала Sunrise.",
  "You can now use it to regain access to your account if you forget your password.": "Сега можете да го използвате, за да възстановите достъп до акаунта си, ако забравите паролата си.",
  "You can't remove this temporal item": "Не можете да премахнете този временен елемент",
  "You don't have permission to view clocked times": "Нямате разрешение да преглеждате отчетеното време",
  "You don't have permissions to take a photo": "Нямате разрешение да направите снимка.",
  "You were signed out automatically": "Излязохте автоматично. Токенът е изтекъл. Можете да влезете отново с вашите данни.",
  "Your password and confirmation password do not match": "Вашата парола и потвърдяващата парола не съвпадат",
  "Your password has been changed successfully!": "Вашата парола е променена успешно!",
  "Your password has expired. Please compose a new password and log in again.": "Вашата парола е изтекла. Моля, съставете нова парола и влезте отново.",
  "Your password must contain at least eight characters": "Вашата парола трябва да съдържа поне осем знака",
  "Your password must contain at least eight characters, at least one number and both lower and uppercase letters.": "Вашата парола трябва да съдържа поне осем знака, поне едно число и както малки, така и главни букви.",
  "Your recovery email is already verified!": "Вашият имейл за възстановяване вече е потвърден!",
  "Your session has expired. Please sign in again.": "Вашата сесия е изтекла. Моля, влезте отново."
};
